import * as THREE from 'three';
import { settings } from '@/config';

/**
 * Thin wrapper around THREE.Scene. Provides a single seam for background, fog
 * and environment so the rest of the app never touches the raw scene config.
 */
export class SceneManager {
  readonly scene = new THREE.Scene();

  constructor() {
    this.scene.background = new THREE.Color(settings.renderer.clearColor);
    if (settings.fog.enabled) {
      // Linear (not exponential) fog ON PURPOSE — `near` gives an explicit "stay
      // clear up to here" distance around the camera, which FogExp2 can't express
      // (it starts attenuating from distance 0). That's exactly the "don't want too
      // much fog near the camera" control asked for.
      this.scene.fog = new THREE.Fog(settings.fog.color, settings.fog.near, settings.fog.far);
    }
  }

  add(...objects: THREE.Object3D[]): void {
    this.scene.add(...objects);
  }

  remove(...objects: THREE.Object3D[]): void {
    this.scene.remove(...objects);
  }

  dispose(): void {
    this.scene.clear();
  }
}
